import React from "react";
import DashboardEventItem from "../../components/dashboard-event-item/DashboardEventItem.component";
import animationData from "../../assets/animation/lf20_4eo2289h.json";
import "./SingleEventContainer.styles.css";
import moment from "moment";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";

import DashboardEventItemMobile from "../../components/dashboard-event-item/DashboardEventItemMobile.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import useWindowSize from "../../hooks/useWindowSize";
import { getEventColor } from "../../utils/helperFn";
import StatusControl from "../../components/status-control/StatusControl.component";
import TextTruncate from "react-text-truncate";
import EventModalComponent from "../../components/available-events-item/EventModal.component.jsx";
import { useNavigate } from "react-router-dom";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <FontAwesomeIcon
        icon={regular("chevron-right")}
        className="text-blue-gray-700"
      />
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <FontAwesomeIcon
        icon={regular("chevron-left")}
        className="text-blue-gray-700"
      />
    </div>
  );
}

const SingleEventHeaderContainer = ({ taskData, refId = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const calcProgress = () => {
    let completedCount = taskData.count.completedTasks;
    let totalTaskCount =
      taskData.count.completedTabCount + taskData.count.notCompletedTabCount;

    if (completedCount > 0 && totalTaskCount > 0) {
      const progress = (completedCount / totalTaskCount) * 100;
      return (
        (progress > 0 ? progress.toFixed(2).replace(/\.00$/, "") : "0") + "%"
      );
    } else if (completedCount === 0 && taskData.eventStatus !== "FINISHED") {
      return "0%";
    }
    if (taskData.eventStatus === "FINISHED") {
      return t("none");
    }
  };

  const calcRemTasks = () => {
    if (taskData.count.notCompletedTabCount === 0) return t("none");
    return taskData.count.notCompletedTabCount;
  };

  const [handleModal, handleModalChange] = React.useState({
    isOpen: false,
    data: taskData,
  });

  const eventHandler = () => {
    handleModalChange({
      ...handleModal,
      isOpen: !handleModal.isOpen,
    });
  };

  const data = React.useMemo(
    () => [
      {
        title: calcProgress(),
        subTitle: t("current_progress"),
        animation: {
          data: animationData,
          width: 20,
          height: 20,
        },
        widthFactor: "3",
      },
      {
        title: calcRemTasks(),
        subTitle: t("remaining_tasks"),
        animation: {
          data: animationData,
          width: 20,
          height: 20,
        },
        widthFactor: "3",
      },
      {
        title: moment(taskData.endDate).format("MMM Do YYYY @ hh:mm A"),
        iconClass: regular("timer"),
        subTitle: t("event_deadline"),
        widthFactor: "3",
      },
    ],
    [t]
  );

  // eslint-disable-next-line
  const [eventData, setEventData] = React.useState(data);
  const isMobile = useWindowSize();

  React.useEffect(() => {
    setEventData(data);
  }, [t]);

  const loadEventData = () =>
    eventData.map((el, index) => <DashboardEventItem key={index} data={el} />);
  const loadMobileEventData = () =>
    eventData.map((el, index) => (
      <DashboardEventItemMobile key={index} data={el} t={t} />
    ));

  const loadEventSlider = () => {
    const settings = {
      className: "slider variable-width cm-mobile-event-dash-slider",
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };

    return (
      <div>
        <Slider {...settings}>{loadMobileEventData()}</Slider>
      </div>
    );
  };
  const viewReportButtonFlag = React.useMemo(() => {
    if (taskData?.sharedEventReportCount > 0) {
      return true;
    }
    if (taskData?.candidateAllTaskList?.length > 0) {
      return taskData.candidateAllTaskList.some((el) => el?.sharedTaskReport);
    }
    return false;
  }, [taskData?.candidateAllTaskList, taskData?.sharedEventReportCount]);

  return (
    <div className="cm-event-dashboard-wrap cm-single-event-dashboard-wrap bg-blue-gray-50 py-3 px-4">
      <div className="px-3">
        {eventData.length > 0 ? (
          <>
            <div className="d-flex align-items-center mb-3 pe-3">
              <h3
                className="cm-event-name my-0 text-blue-700 fw-semibold cm-fs-16"
                title={taskData.eventName}
              >
                <TextTruncate
                  line={2}
                  element="span"
                  truncateText="…"
                  text={taskData.eventName}
                />
              </h3>
              <span
                className={`cm-event-status-pill my-0 ms-2 cm-sm-txt fw-medium rounded-pill cm-fs-12 text-nowrap text-capitalize ${getEventColor(
                  taskData.eventStatus
                )}`}
              >
                <StatusControl value={taskData.eventStatus} />{" "}
              </span>
              <div
                className="mx-3"
                style={{
                  width: "1px",
                  height: "18px",
                  backgroundColor: "#D9D9D9",
                }}
              />
              <button
                className={`btn cm-trans-btn-light text-action-blue bg-white cm-pointer border-action-blue fw-medium cm-sm-txt d-flex`}
                onClick={() => eventHandler()}
              >
                <p className="mb-0">{t("view_instructions")}</p>
                <FontAwesomeIcon
                  className="ms-2 my-auto"
                  icon={regular("angle-right")}
                />
              </button>
              {viewReportButtonFlag && (
                <button
                  className={`btn cm-trans-btn-light text-action-blue bg-white cm-pointer border-action-blue fw-medium cm-sm-txt ms-2 d-flex`}
                  onClick={() => {
                    navigate(
                      `/candidate-report?eventId=${
                        taskData.eventId
                      }&reportType=${
                        taskData?.sharedEventReportCount > 0 ? "EVENT" : "TASK"
                      }${refId ? `&refId=${refId}` : ""}`
                    );
                  }}
                >
                  <FontAwesomeIcon
                    className="me-2 my-auto"
                    icon={regular("file-alt")}
                  />
                  <p className="mb-0">{t("view_reports")}</p>
                </button>
              )}
            </div>
            {eventData.length > 0 ? (
              !isMobile.isMobile ? (
                <div className="d-flex cm-task-dash-wrap">
                  {loadEventData()}
                </div>
              ) : (
                loadEventSlider()
              )
            ) : (
              <DashboardEventItem isEmpty={true} t={t} />
            )}
          </>
        ) : (
          <DashboardEventItem isEmpty={true} />
        )}
      </div>
      <EventModalComponent
        t={t}
        eventId={taskData.eventId}
        handleModal={handleModal}
        eventTimeline={`${moment(handleModal.data.startDate).format(
          "MMM DD YYYY @ hh:mm A"
        )} ${
          !!handleModal.data.endDate &&
          `- ${moment(handleModal.data.endDate).format(
            "MMM DD YYYY @ hh:mm A"
          )}`
        }`}
        handleModalChange={handleModalChange}
      />
    </div>
  );
};

export default SingleEventHeaderContainer;
